export default {
  basic: () => import("/codebuild/output/src3951285042/src/airtableforms/client/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/codebuild/output/src3951285042/src/airtableforms/client/layouts/default.vue").then(m => m.default || m)
}